import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { SharedService } from '../../shared.service';

@Component({
  selector: 'app-delears',
  templateUrl: './delears.component.html',
  styleUrls: ['./delears.component.css']
})
export class DelearsComponent implements OnInit {

  delearForm: FormGroup;
  searchString: any = '';
  sales_officers = [] as any

  toggle = true;
  loading = false;
  error: any;

  project = JSON.parse(localStorage.getItem('project') || '');

  channelPartners:any;
  currentUser:any;

  isloading = true;

  constructor(
    private _formBuilder: FormBuilder,
    private SharedService: SharedService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.channelPartners = [];
    this.sales_officers = [];
    this.isloading = true;

    this.SharedService.users().subscribe((response) => {
      response.data.forEach(user => {
        if(user.project === this.project._id ){
          if(user.role === 'sales' || user.role === 'manager'){
            this.sales_officers.push(user)
          }
        }
      });
      console.log(this.sales_officers)
    },
      (error) => {
        console.log(error);
      })


    this.toggle = true;
    this.currentUser = this.SharedService.getUser();
    this.delearForm = this._formBuilder.group({
      _id:[null],
      name: ['', [Validators.required]],
      company_name: ['', [Validators.required]],
      contact: ['', [Validators.required]],
      comission: ['', [Validators.required]],
      type: ['firm', [Validators.required]],
      rera_number: ['', [Validators.required]],
      sales_officer: ['', [Validators.required]],
      email: ['',[Validators.required]],
      address: ['', [Validators.required]],
      project: [''],
    });

    this.SharedService.getDelaers().subscribe((resp:any)=>{
      const cp = [] as any;
      if(this.currentUser.role === 'sales'){
        resp.data.forEach(element => {
          if(element.sales_officer._id === this.currentUser._id){
            cp.push(element);
          }
        });
        this.channelPartners = cp;
      }else{
        this.channelPartners = resp.data;
      }

      this.isloading = false;
    })
  }

  info(delear:any) {
    this.router.navigate(['dashboard/channel-partners/subdelear'],{ fragment: delear._id.toString() });
  }

  back(){
    this.toggle = !this.toggle;
    this.delearForm.reset();
    this.delearForm.patchValue({
      type: 'firm',
      sales_officer: ''
    });
  }

  edit(delear:any){
    console.log(delear)
    this.delearForm.patchValue(delear);
    if( delear.sales_officer){
      this.delearForm.patchValue({sales_officer: delear.sales_officer._id});
    }

    this.toggle = false;
  }

  export(){

  }


  onSubmit(): any {
    if (this.delearForm.invalid) {
      this.Toast.fire({
        title: 'Error!',
        text: 'Please fill all required fields',
        icon: 'error'
      })
      return
    }
     else if(!this.delearForm.value._id) {
      this.loading = true;
      this.delearForm.patchValue({project: this.project._id})
      this.SharedService.CreateDelaer(this.delearForm.value).subscribe((response) => {
        console.log(response);
        this.Toast.fire({
          title: 'Done!',
          text: 'Channel partner has been created',
          icon: 'success'
        })
        this.loading = false;
        window.scrollTo(0, 0);
        this.ngOnInit();

      },
        (error) => {
          console.log(error);
          this.Toast.fire({
            title: 'Error!',
            text: error.error.message,
            icon: 'error'
          })
          this.loading = false;
        })
    }else if(this.delearForm.value._id) {
      this.loading = true;
      this.SharedService.UpdateDelaer(this.delearForm.value._id,this.delearForm.value).subscribe((response) => {
        console.log(response);
        this.Toast.fire({
          title: 'Done!',
          text: 'Channel partner has been updated',
          icon: 'success'
        })
        this.loading = false;
        window.scrollTo(0, 0);
        this.ngOnInit();

      },
        (error) => {
          console.log(error);
          this.Toast.fire({
            title: 'Error!',
            text: error.error.message,
            icon: 'error'
          })
          this.loading = false;
        })
    }
  }

  delete(cp: any): any {

    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to delete CP - ' + cp.name,
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        this.SharedService.deleteDelaer(cp._id).subscribe(response => {
          console.log(response)
          this.Toast.fire({
            title: 'Deleted!',
            text: 'The CP and its Sub Brokers has been deleted',
            icon: 'success'
          })
          this.ngOnInit();
        },
        (error)=>{
          console.log(error);
          this.Toast.fire({
            title: 'Error!',
            text: error.error,
            icon: 'error',
          });
        })

      }
    })

}

  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

}
